import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { formatDynamicDateRange } from 'lib/datetime/dateUtils'
import useCharterFlightDates from 'hooks/CharterFlights/useCharterFlightDates'

type Params = Parameters<typeof useCharterFlightDates>[0] & {
  checkOutDate?: string
  fallbackLabel: string
}

export default function useFlashMobileCharterDateLabel(params: Params) {
  const { checkInDate, checkOutDate, nights, charterBundleRoute, fallbackLabel } = params
  const { departDate } = useCharterFlightDates(params)

  if (!charterBundleRoute || !checkInDate) return fallbackLabel

  const checkOut = checkOutDate ?? (nights ? moment(checkInDate).add(nights, 'days').format(ISO_DATE_FORMAT) : undefined)
  return formatDynamicDateRange(departDate || checkInDate, checkOut)
}
